export const DELETE_SLIDE_NAME_REQUEST = " DELETE_SLIDE_NAME_REQUEST";
export const DELETE_SLIDE_NAME_SUCCESS = " DELETE_SLIDE_NAME_SUCCESS";
export const DELETE_SLIDE_NAME_FAILURE = " DELETE_SLIDE_NAME_FAILURE";
